// #viet_code
import React from 'react';
import moment from 'moment';

const MaintenanceBatchPrintTemplate = React.forwardRef(({data}, ref) => {
    if (!data) return null;

    const events = data.maintenanceEvents || [];
    const totalCost = events.reduce((sum, e) => sum + (e.cost || 0), 0);

    return (
        <div ref={ref} className="print-template" style={{
            padding: '20px',
            color: '#333',
            fontFamily: 'Times New Roman, serif',
            fontSize: '14px',
            lineHeight: '1.6'
        }}>
            {/* Header / Quốc hiệu tiêu ngữ */}
            <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '30px'}}>
                <div style={{textAlign: 'center', width: '40%'}}>
                    <div style={{fontWeight: 'bold', fontSize: '13px'}}>ĐƠN VỊ: CNTT 108</div>
                    <div style={{fontSize: '12px'}}>SỐ: {data.batchCode}</div>
                </div>
                <div style={{textAlign: 'center', width: '50%'}}>
                    <div style={{fontWeight: 'bold', fontSize: '14px'}}>CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>
                    <div style={{fontWeight: 'bold', fontSize: '14px'}}>Độc lập - Tự do - Hạnh phúc</div>
                    <div style={{borderBottom: '1px solid #000', width: '60%', margin: '5px auto'}}></div>
                    <div style={{fontStyle: 'italic', marginTop: '10px'}}>Hà Nội, ngày {moment().format('DD')} tháng {moment().format('MM')} năm {moment().format('YYYY')}</div>
                </div>
            </div>

            {/* Title */}
            <div style={{textAlign: 'center', marginBottom: '30px'}}>
                <h2 style={{fontWeight: 'bold', fontSize: '20px', textTransform: 'uppercase', marginBottom: '5px'}}>PHIẾU YÊU CẦU SỬA CHỮA / BẢO TRÌ</h2>
                <div style={{fontStyle: 'italic'}}>(Kiêm biên bản bàn giao tài sản)</div>
            </div>

            {/* General Info */}
            <div style={{marginBottom: '20px'}}>
                <p><strong>Người yêu cầu:</strong> {data.createdBy || '.................................'}</p>
                <p><strong>Tiêu đề đợt sửa chữa:</strong> {data.title}</p>
                <p><strong>Loại sửa chữa / Bảo trì:</strong> {data.batchType || 'Sửa chữa'}</p>
                <p><strong>Người thực hiện:</strong> {data.performedBy || 'Chưa rõ'}</p>
                <p><strong>Ghi chú:</strong> {data.notes || 'N/A'}</p>
            </div>

            {/* Table */}
            <table style={{
                width: '100%',
                borderCollapse: 'collapse',
                marginBottom: '30px'
            }}>
                <thead>
                    <tr>
                        <th style={tableHeaderStyle}>STT</th>
                        <th style={tableHeaderStyle}>Mã tài sản</th>
                        <th style={tableHeaderStyle}>Tên tài sản</th>
                        <th style={tableHeaderStyle}>Nội dung sửa chữa</th>
                        <th style={tableHeaderStyle}>Kết quả sửa chữa</th>
                        <th style={tableHeaderStyle}>Dự kiến chi phí</th>
                    </tr>
                </thead>
                <tbody>
                    {events.map((evt, index) => (
                        <tr key={index}>
                            <td style={{...tableCellStyle, textAlign: 'center'}}>{index + 1}</td>
                            <td style={{...tableCellStyle, textAlign: 'center'}}>{evt.assetCode || '-'}</td>
                            <td style={tableCellStyle}>{evt.assetName || '-'}</td>
                            <td style={tableCellStyle}>{evt.eventName}</td>
                            <td style={{...tableCellStyle, textAlign: 'center'}}>{evt.repairResult || '-'}</td>
                            <td style={{...tableCellStyle, textAlign: 'right'}}>{(evt.cost || 0).toLocaleString('vi-VN')} đ</td>
                        </tr>
                    ))}
                    <tr>
                        <td colSpan="5" style={{...tableCellStyle, textAlign: 'right', fontWeight: 'bold'}}>TỔNG CỘNG ({events.length} thiết bị)</td>
                        <td style={{...tableCellStyle, textAlign: 'right', fontWeight: 'bold'}}>{totalCost.toLocaleString('vi-VN')} đ</td>
                    </tr>
                </tbody>
            </table>
            
            {/* Materials Table */}
            {events.some(e => e.materials && e.materials.length > 0) && (
                <>
                    <h4 style={{fontWeight: 'bold', fontSize: '16px', marginBottom: '10px'}}>DANH SÁCH VẬT TƯ / PHỤ KIỆN</h4>
                    <table style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        marginBottom: '30px'
                    }}>
                        <thead>
                            <tr>
                                <th style={tableHeaderStyle}>STT</th>
                                <th style={tableHeaderStyle}>Tên vật tư / Phụ kiện</th>
                                <th style={tableHeaderStyle}>Số lượng</th>
                                <th style={tableHeaderStyle}>Dự kiến đơn giá</th>
                                <th style={tableHeaderStyle}>Thành tiền</th>
                                <th style={tableHeaderStyle}>Ghi chú</th>
                            </tr>
                        </thead>
                        <tbody>
                            {events.flatMap(e => e.materials || []).map((m, mIdx) => (
                                <tr key={mIdx}>
                                    <td style={{...tableCellStyle, textAlign: 'center'}}>{mIdx + 1}</td>
                                    <td style={tableCellStyle}>{m.materialName || 'Vật tư'}</td>
                                    <td style={{...tableCellStyle, textAlign: 'center'}}>{m.quantity}</td>
                                    <td style={{...tableCellStyle, textAlign: 'right'}}>{(m.unitPrice || 0).toLocaleString('vi-VN')} đ</td>
                                    <td style={{...tableCellStyle, textAlign: 'right'}}>{((m.quantity || 0) * (m.unitPrice || 0)).toLocaleString('vi-VN')} đ</td>
                                    <td style={tableCellStyle}>{m.note || '-'}</td>
                                </tr>
                            ))}
                            <tr>
                                <td colSpan="4" style={{...tableCellStyle, textAlign: 'right', fontWeight: 'bold'}}>TỔNG TIỀN VẬT TƯ</td>
                                <td colSpan="2" style={{...tableCellStyle, textAlign: 'left', fontWeight: 'bold'}}>
                                    {events.reduce((sum, e) => sum + (e.materials || []).reduce((mSum, m) => mSum + (m.quantity * m.unitPrice), 0), 0).toLocaleString('vi-VN')} đ
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </>
            )}

            {/* Footer / Signatures */}
            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '50px', textAlign: 'center'}}>
                <div style={{width: '30%'}}>
                    <div style={{fontWeight: 'bold'}}>NGƯỜI LẬP PHIẾU</div>
                    <div style={{fontStyle: 'italic', fontSize: '12px'}}>(Ký, ghi rõ họ tên)</div>
                    <div style={{height: '80px'}}></div>
                    <div style={{fontWeight: 'bold'}}>{data.createdBy}</div>
                </div>
                <div style={{width: '30%'}}>
                    <div style={{fontWeight: 'bold'}}>TRƯỞNG BỘ PHẬN</div>
                    <div style={{fontStyle: 'italic', fontSize: '12px'}}>(Ký, ghi rõ họ tên)</div>
                    <div style={{height: '80px'}}></div>
                </div>
                <div style={{width: '30%'}}>
                    <div style={{fontWeight: 'bold'}}>LÃNH ĐẠO PHÊ DUYỆT</div>
                    <div style={{fontStyle: 'italic', fontSize: '12px'}}>(Ký, ghi rõ họ tên)</div>
                    <div style={{height: '80px'}}></div>
                </div>
            </div>

            {/* CSS inline for printing */}
            <style>
                {`
                @media print {
                    .print-template { padding: 0 !important; }
                    button { display: none !important; }
                }
                `}
            </style>
        </div>
    );
});

const tableHeaderStyle = {
    border: '1px solid #000',
    padding: '8px',
    backgroundColor: '#f2f2f2',
    fontWeight: 'bold',
    textAlign: 'center'
};

const tableCellStyle = {
    border: '1px solid #000',
    padding: '8px',
    verticalAlign: 'middle'
};

export default MaintenanceBatchPrintTemplate;
